import { render, staticRenderFns } from "./MediaLibraryButtonUpload.vue?vue&type=template&id=64085c08&"
import script from "./MediaLibraryButtonUpload.vue?vue&type=script&lang=js&"
export * from "./MediaLibraryButtonUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports